import { bl_fi_entity_sales_credit_terms_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class SalesCreditTermsContainerModel extends BaseContainerModel{
    bl_fi_entity_sales_credit_terms: bl_fi_entity_sales_credit_terms_RowClass=new bl_fi_entity_sales_credit_terms_RowClass();
}